// extracted by mini-css-extract-plugin
export default {"desktop":"DesktopNavigation_desktop__+qgnu","desktop__main-menu":"DesktopNavigation_desktop__main-menu__SI+ae"};